export const TOKEN_INITIATED = 'TOKEN_INITIATED';
export const TOKEN_RECEIVED = 'TOKEN_RECEIVED';
export const TOKEN_ERROR = 'TOKEN_ERROR';
export const UUID_INITIATED = 'UUID_INITIATED';
export const UUID_RECEIVED = 'UUID_RECEIVED';
export const UUID_ERROR = 'UUID_ERROR';
export const ECE_CONNECTED = 'ECE_CONNECTED';
export const ECE_CONNECT_ERROR = 'ECE_CONNECT_ERROR';
export const ECE_GENERIC_ERROR = 'ECE_GENERIC_ERROR';
export const AGENT_CONNECTED = 'AGENT_CONNECTED';
export const SURVEY_SHOWN = 'SURVEY_SHOWN';
export const SURVEY_SUBMITTED = 'SURVEY_SUBMITTED';
export const DISPOSITION_ENDPOINT = 'DISPOSITION_ENDPOINT';

export const initiateToken = (genericId) => ({
    type: TOKEN_INITIATED,
    payload: genericId
});

export const receiveToken = () => ({
    type: TOKEN_RECEIVED
});

export const onTokenError = (type) => ({
    type: TOKEN_ERROR,
    payload: type
});

export const initiateUuid = () => ({
    type: UUID_INITIATED
});

export const receiveUuid = (uid) => ({
    type: UUID_RECEIVED,
    payload: uid
});

export const onUuidError = (type) => ({
    type: UUID_ERROR,
    payload: type
});

export const connectEce = () => ({
    type: ECE_CONNECTED
});

export const onEceError = (type) => ({
    type: type
});

export const connectAgent = (agentName) => ({
    type: AGENT_CONNECTED,
    payload: agentName
});

export const showSurvey = () => ({
    type: SURVEY_SHOWN
});

export const submitSurvey = () => ({
    type: SURVEY_SUBMITTED
});

export const setDispositionEndpoint = (url) => ({
    type: DISPOSITION_ENDPOINT,
    payload: url
});